/* eslint-disable jsx-a11y/iframe-has-title */
/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-11 20:59:31
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-11 23:01:37
 */

import React, { Fragment } from 'react';
import { shape } from 'prop-types';
import styled from 'styled-components';
import { HelmetWrapper } from '../../components';

const FullScreenIframe = styled.section`
position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  iframe {
  width: 100%;
  height: 100%;
}
`;

function CreditCard(props) {
  const { location } = props;
  return (
    <Fragment>
      <HelmetWrapper location={location} />
      <FullScreenIframe>
        <iframe
          frameBorder="0"
          src="https://multiatesting.in/zaggle-zatix/"
          allowFullScreen
        >
        </iframe>
      </FullScreenIframe>
    </Fragment>
  );
}

CreditCard.propTypes = {
  location: shape({}).isRequired,
};

export default CreditCard;



// WEBPACK FOOTER //
// client/containers/CreditCard/index.js